module.exports = __webpack_public_path__ + "static/media/infografia.b66908c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/modelo/infografia.png
// module id = 186
// module chunks = 0